var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrowIcon = function SvgRightArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.933 11.664a.9.9 0 0 0-.212-.309l-8.444-8.088a.98.98 0 0 0-1.347 0 .885.885 0 0 0 0 1.29l6.818 6.53H2.952c-.526 0-.952.41-.952.913s.426.912.952.912h15.796l-6.818 6.53a.885.885 0 0 0 0 1.29.98.98 0 0 0 1.347 0l8.44-8.082.046-.047A.9.9 0 0 0 22 12M21.933 11.664a.9.9 0 0 1 .067.333z"
  })));
};
export default SvgRightArrowIcon;